const DEFAULT_JO_PREFIX = "WO";

export function getJobOrderPrefix() {
  return process.env.VUE_APP_JO_PREFIX || DEFAULT_JO_PREFIX;
}

export function getJobOrderNumber(id) {
  const identifier = typeof id === "number" ? id : parseInt(id, 10) || 0;
  const padded = identifier.toString().padStart(5, 0);
  return `${getJobOrderPrefix()}-${padded}`;
}

